module.exports = san.defineComponent({
    template: require('../views/IntelligentGeneration/doc-ldbc.html'),
    initData: function () {
        return {
            explain: 0,
            showAlert: false,
            ApplicantList: [{
                name: '',
                sex: '男',
                birthDate: '',
                cardId: '',
                address: '',
                domicile:'',
                tel: ''
            }],
            ClaimantList: [{
                companyName: '',
                companyAddress: '',
                legalRepresentative: '',
                tel: ''
            }],
            RequestList: [{
                laborRemuneration: '',
            }],
            EvidenceList: [{
                workingTime: '',
                jobPosition: '',
                averageWage: '',
                //failWageType:'1',
                failWageStartTime: '',
                failWageEndTime: '',
                failWages: '',
                failMonth: '',
                courtName:'',
                loanDate4:''

            }],
            proofList: [{
                laborContract: false,
                salaryBill: false,
                bankCard: false,
                mobilePayment: false,
                otherMaterials: false,
                otherEvidence: ""
            }], //证据列表
            otherEvidence2: [],
            ifCreate: false,
            uid: '',
            id: 6,
            tipMessage: '',
            seedFail: true,//邮箱发送失败
            email: '',
            emailAddress: '',
            result: {},
            re: [],
            qtre: [],
            qrcodeUrl2: '',
            shadowNum:0,
            message:'发送中...'
        };
    },
    components: {},
    created: function () {
        var list = this.data.get('EvidenceList');
        var list2 = this.data.get('ApplicantList');
        list[0].workingTime = this.createDate();
        list[0].failWageStartTime = this.createDate();
        list[0].failWageEndTime = this.createDate();
        list[0].loanDate4 = this.createDate();
        list2[0].birthDate = this.createDate();
        this.data.set('EvidenceList',list);
        this.data.set('ApplicantList',list2);
        this.data.set('ifCreate',false);
        this.data.set('showAlert',false);
    },
    attached: function(){
        var me=this;
        $('#mydatepicker1').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            me.data.set('ApplicantList[0].birthDate',"");
            me.data.set('ApplicantList[0].birthDate',e.date);
        }); //初始化日期选择器
        $('#mydatepicker2').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            me.data.set('EvidenceList[0].workingTime',"");
            me.data.set('EvidenceList[0].workingTime',e.date);
        }); //初始化日期选择器
        $('#mydatepicker3').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            me.data.set('EvidenceList[0].failWageStartTime',"");
            me.data.set('EvidenceList[0].failWageStartTime',e.date);
            me.countWages();
        }); //初始化日期选择器
        $('#mydatepicker4').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            me.data.set('EvidenceList[0].failWageEndTime',"");
            me.data.set('EvidenceList[0].failWageEndTime',e.date);
            me.countWages();
        }); //初始化日期选择器
        $('#mydatepicker5').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            me.data.set('EvidenceList[0].loanDate4',"");
            me.data.set('EvidenceList[0].loanDate4',e.date);
        }); //初始化日期选择器
    },
    hide: function () {
        this.data.set('explain',0);
    },
    createDate: function () {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentDate = year + seperator1 + month + seperator1 + strDate;
        return currentDate;
    },
    addEvidence: function () {
        if (this.data.get('otherEvidence2').length < 20) {
            this.data.push('otherEvidence2',{
                evidenceName: '',
            });
        } else {
            this.dispatch('showAlert',{title:'提示',msg:"证据最多添加20项"});
        }
    },
    del: function (index) {
        this.data.splice('otherEvidence2', [index, 1]);
    },
    getBirthdayFromIdCard: function (idCard, index, type) {
        if (idCard != '') {
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            var me = this;
            if (reg.test(idCard) === false) {
                this.dispatch('showAlert',{title:'提示',msg:"身份证输入不合法"});
                return;
            }
            var birthday = "";
            if (idCard != null && idCard != "") {
                if (idCard.length == 15) {
                    birthday = "19" + idCard.substr(6, 6);
                } else if (idCard.length == 18) {
                    birthday = idCard.substr(6, 8);
                }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
                var date = new Date(birthday.replace(/-/g, '/'));
                if (!date.getFullYear() || !date.getMonth() || !date.getDate()) {
                    this.dispatch('showAlert',{title:'提示',msg:"身份证号码有误"});
                    return;
                }
                switch (type) {
                    case 1:
                        san.nextTick(function () {
                            me.data.set("ApplicantList[" + index + "].birthDate",birthday);
                        });
                        break;
                    case 3:
                        san.nextTick(function () {
                            me.data.set("ClaimantList[" + index + "].birthDate",birthday);
                        });
                        break;
                }
            }
        }
    },
    //根据欠薪起止时间计算拖欠工资
    countWages: function () {
        var me = this;
        if (this.data.get('EvidenceList[0].averageWage') != '') {
            var list = this.data.get('EvidenceList[0]');
            var d1 = new Date(list.failWageStartTime.replace(/-/g, '/')).getTime();
            var d2 = new Date(list.failWageEndTime.replace(/-/g, '/')).getTime();
            if (d2 >= d1) {
                list.failMonth = ((d2 - d1) / 1000 / 3600 / 24 / 365 * 12).toFixed(2);
                list.failWages = (list.averageWage * 12 / 365 * ((d2 - d1) / 1000 / 3600 / 24)).toFixed(2);
            } else {
                list.failMonth = 0;
                list.failWages = 0;
            }
        }
        me.data.set('EvidenceList[0].failMonth','');
        me.data.set('EvidenceList[0].failWages','');
        san.nextTick(function () {
            me.data.set('EvidenceList[0].failMonth',list.failMonth);
            me.data.set('EvidenceList[0].failWages',list.failWages);
        });
    },
    createWs: function () {
        var me = this;
        var returnFlag = true;
        me.data.get('ApplicantList').map(function (element, index, arr) {
            if (element.name == '') {
                me.dispatch('showAlert',{title:'提示',msg:"申请人姓名不能为空"});
                returnFlag = false;
                return;
            }
            if (element.cardId == '') {
                me.dispatch('showAlert',{title:'提示',msg:"申请人身份证号不能为空"});
                returnFlag = false;
                return;
            }
            var date = me.data.get("ApplicantList[" + index + "].birthDate");
            if(typeof date == "string"){
                date = new Date(date.replace(/-/g, '/'));
            }
            if (!date.getFullYear() || !date.getMonth() || !date.getDate()) {
                me.data.set("me.ApplicantList[" + index + "].birthDate",'');
            }
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (reg.test(element.cardId) === false) {
                me.dispatch('showAlert',{title:'提示',msg:"申请人身份证号不合法"});
                returnFlag = false;
                return;
            }
            if (element.address == '') {
                me.dispatch('showAlert',{title:'提示',msg:"申请人住址不能为空"});
                returnFlag = false;
                return;
            }
            if (element.domicile == '') {
                me.dispatch('showAlert',{title:'提示',msg:"申请人户籍地不能为空"});
                returnFlag = false;
                return;
            }
            if (element.tel == '') {
                me.dispatch('showAlert',{title:'提示',msg:"申请人联系电话不能为空"});
                returnFlag = false;
                return;
            }
        });
        if (returnFlag == false) {
            return;
        }
        me.data.get('ClaimantList').map(function (element, index, arr) {
            if (element.companyName == '') {
                me.dispatch('showAlert',{title:'提示',msg:"被申请人公司名称不能为空"});
                returnFlag = false;
                return;
            }
            if (element.companyAddress == '') {
                me.dispatch('showAlert',{title:'提示',msg:"被申请人公司地址不能为空"});
                returnFlag = false;
                return;
            }
            if (element.legalRepresentative == '') {
                me.dispatch('showAlert',{title:'提示',msg:"被申请人公司法定代表人不能为空"});
                returnFlag = false;
                return;
            }
        });
        if (returnFlag == false) {
            return;
        }
        me.data.get('EvidenceList').map(function (element, index, arr) {
            var date1,date2, date3;
            if (element.workingTime == '') {
                me.dispatch('showAlert',{title:'提示',msg:"入职时间不能为空"});
                returnFlag = false;
                return;
            }
            if (element.jobPosition == '') {
                me.dispatch('showAlert',{title:'提示',msg:"工作岗位不能为空"});
                returnFlag = false;
                return;
            }
            if (element.averageWage == '') {
                me.dispatch('showAlert',{title:'提示',msg:"月工资不能为空"});
                returnFlag = false;
                return;
            }
            if (element.failWageStartTime == '') {
                me.dispatch('showAlert',{title:'提示',msg:"离职初始时间不能为空"});
                returnFlag = false;
                return;
            }
            if (element.failWageEndTime == '') {
                me.dispatch('showAlert',{title:'提示',msg:"离职截止时间不能为空"});
                returnFlag = false;
                return;
            }
            if (element.workingTime != '') {
                date1 = new Date(element.workingTime.replace(/-/g, '/')).getTime();
            }
            if (element.failWageStartTime != '') {
                date2 = new Date(element.failWageStartTime.replace(/-/g, '/')).getTime();
            }
            if (element.failWageEndTime != '') {
                date3 = new Date(element.failWageEndTime.replace(/-/g, '/')).getTime();
            }
            if(date1 > date2 || date1 > date3){
                me.dispatch('showAlert',{title:'提示',msg:"入职时间不得晚于离职时间"});
                returnFlag = false;
                return;
            }
            if (date3 < date2) {
                me.dispatch('showAlert',{title:'提示',msg:"离职结束时间不得晚于开始时间"});
                returnFlag = false;
                return;
            }
            if (element.failWages == '') {
                me.dispatch('showAlert',{title:'提示',msg:"少发/未发工资不能为空"});
                returnFlag = false;
                return;
            }
            if (element.courtName == '') {
                me.dispatch('showAlert',{title:'提示',msg:"仲裁委员会不能为空"});
                returnFlag = false;
                return;
            }
            if (element.loanDate4 == '') {
                me.dispatch('showAlert',{title:'提示',msg:"填写日期不能为空"});
                returnFlag = false;
                return;
            }
        });
        if (returnFlag == false) {
            return;
        }
        var result2 = {
            applicantList: me.data.get('ApplicantList'),
            claimantList: me.data.get('ClaimantList'),
            //requestList: this.RequestList,
            evidenceList: me.data.get('EvidenceList'),
            proofList: me.data.get('proofList'),
            consultType: 3
        };
        var result = JSON.parse(JSON.stringify(result2));
        var a = /^(\d{4})-(\d{2})-(\d{2})$/;
        result.evidenceList.map(function (element, index, arr) {
            if (element.workingTime != '') {
                var date = new Date(element.workingTime.split('T')[0].replace(/-/g, '/'));
                element.workingTime = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
            if (element.failWageStartTime != '') {
                var date = new Date(element.failWageStartTime.split('T')[0].replace(/-/g, '/'));
                element.failWageStartTime = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
            if (element.failWageEndTime != '') {
                var date = new Date(element.failWageEndTime.split('T')[0].replace(/-/g, '/'));
                element.failWageEndTime = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
            if (element.loanDate4 != '') {
                var date = new Date(element.loanDate4.split('T')[0].replace(/-/g, '/'));
                element.loanDate4 = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
        });
        result.applicantList.map(function (element, index, arr) {
            if (element.birthDate != '') {
                var date;
                if(element.birthDate.split('T')[0] != ''){
                    date = new Date(element.birthDate.split('T')[0].replace(/-/g, '/'));
                }else {
                    date = new Date(element.birthDate.replace(/-/g, '/'));
                }
                if (!date.getFullYear() || !date.getMonth() || !date.getDate()) {
                    me.dispatch('showAlert',{title:'提示',msg:"身份证号码有误"});
                    returnFlag = false;
                    return;
                } else {
                    return element.birthDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
                }
            }
        });
        var ect = "";
        var list = this.data.get('otherEvidence2');
        list.map(function (element, index, arr) {
            if(element.evidenceName){
                if (index > 0) {
                    ect = ect + ",";
                }
                ect = ect + ((index + 1) + "、" + element.evidenceName).toString();
            }
        });
        if(ect !== ""){
            result.proofList[0].otherEvidence = ect;
        }
        me.data.set('result',result);
        this.zj();
        this.el.scrollTop = 0;
        this.data.set('ifCreate',true);
        san.nextTick(function () {
            me.getUID();
        });
    },
    getUID: function () {
        var res = document.getElementById('znwsResult').innerHTML;
        var me = this;
        this.data.set('message','加载中...');
        this.data.set('showLoading',true);
        var params2 = {
            consultType: 3,
            css: '.znws{' +
                'font-family: 仿宋;' +
                '}' +
                '.application-title{' +
                'margin-bottom: 40px;' +
                '}' +
                '.application-title h2 {' +
                'text-align: center;' +
                'font-size: 18pt;' +
                'font-weight: 600;' +
                'margin-bottom: 20px;' +
                'line-height: 150%;' +
                '}' +
                '.result-box {' +
                'font-size: 14pt;' +
                'line-height: 150%;' +
                '}' +
                '.result-box h3 {' +
                'font-weight: bold;' +
                'font-size: 14pt;' +
                'text-indent: 2em;' +
                '}' +
                '.result-box h5 {' +
                'font-size: 12pt;' +
                'margin: 30px 0;' +
                'color: #666;' +
                'font-weight: normal;' +
                '}' +
                '.result-box p {' +
                'text-indent: 2em;' +
                'font-size: 14pt;' +
                '}' +
                '.applicant{' +
                'text-align: right;' +
                'margin-right: 150px;' +
                '}' +
                '.applicant span{' +
                'font-size: 12pt;' +
                '}' +
                '.other-evidence {' +
                'margin: 40px 0;' +
                '}' +
                '.other-evidence p {' +
                'font-size: 14pt;' +
                'text-indent: 2em;' +
                'line-height: 150%;' +
                '}' +
                '.other-evidence h2 {' +
                'font-size: 14pt;' +
                'text-align: center;' +
                'font-weight: 600;' +
                '}' +
                '.other-evidence h3 {' +
                'font-size: 12pt;' +
                'text-align: center;' +
                'color: #a5a5a5;' +
                'text-indent: 2em;' +
                '}',
            body: res,
        };
        Api("post", "/api/writ/v2/getUid", JSON.stringify(params2)).then(function (response) {
            me.data.set('showLoading',false);
            me.data.set('uid',response.uid);
            
            Api("get", `/api/writ/law/document?uid=${response.uid}`).then(function (res) {
                const baseUrl = res.url
                me.createQrcode2(baseUrl);
            });
            me.dispatch('goTop');
        });
    },
    createQrcode2: function (baseUrl) {
        var me = this;
        // 动态生成二维码
        document.getElementById('qrcode2').innerHTML='';
        window.qrcode = new QRCode('qrcode2', {
            text: baseUrl,
            width: 160,
            height: 160
        });
    },
    mail: function () {
        this.data.set('showAlert',true);
    },
    cancel: function () {
        this.data.set('showAlert',false);
    },
    zj: function (){
        this.data.set('re',[]);
        this.data.set('qtre',[]);
        var me = this;
        var arr = new Array();
        var arr2 = this.data.get('result.proofList[0].otherEvidence').split(",");
        var pr = this.data.get('result.proofList[0]');
        arr = [
            {label:"工资条",value:pr.salaryBill},
            {label:"银行卡打卡凭证",value:pr.bankCard},
            {label:"支付宝/微信支付记录",value:pr.mobilePayment},
            {label:"其他工资标准证明材料",value:pr.otherMaterials},
            //{label:pr.otherEvidence,value:true},
        ];
        san.nextTick(function () {
            me.data.set('re',arr);
            me.data.set('qtre',arr2);
        });
    },
    focusing: function (index){
        var me = this;
        san.nextTick(function () {
            me.data.set('shadowNum',index);
        });
    },
    modalSure: function () {
        var me = this;
        this.data.set('showFlag', '1');
        if (this.data.get('email') == '') {
            this.data.set('tipMessage', '邮箱不能为空');
            this.data.set('seedFail', true);
            return;
        }
        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        if (!reg.test(this.data.get('email'))) {
            this.data.set('tipMessage', '邮箱格式不正确');
            this.data.set('seedFail', true);
            return;
        }
        this.data.set('showAlert', false);
        this.data.set('message','发送中...');
        this.data.set('showLoading', true);
        var data;
        var type;
        if (!!this.data.get('ifCreate')) {
            type = 5;
            data = {'uid': me.data.get('uid'), 'toAddress': me.data.get('email')};
            Api("post", "/api/writ/v2/sendmail/" + type, JSON.stringify(data)).then(function (response) {
                window.NewLog._saveLog("SMART_WORD-LABOR", "法律文书-劳动工伤", 1, "追索劳动报酬仲裁申请书", "SEND_MAIL");
                me.data.set('showLoading', false);
                if (response.code == 0) {
                    me.dispatch('showAlert',{title:'提示',msg:"发送成功"});
                } else {
                    me.dispatch('showAlert',{title:'提示',msg:response.msg});
                }
            });
        }
    },
    evidenceChecked:function(type){
        var me = this;
        switch (type) {
            case 1:
                if(this.data.get('proofList[0].laborContract') == true){
                    san.nextTick(function () {
                        me.data.set('proofList[0].laborContract',false)
                    });
                }else {
                    san.nextTick(function () {
                        me.data.set('proofList[0].laborContract',true)
                    });
                }
                break;
            case 2:
                if(this.data.get('proofList[0].salaryBill') == true){
                    san.nextTick(function () {
                        me.data.set('proofList[0].salaryBill',false)
                    });
                }else {
                    san.nextTick(function () {
                        me.data.set('proofList[0].salaryBill',true)
                    });
                }
                break;
            case 3:
                if(this.data.get('proofList[0].bankCard') == true){
                    san.nextTick(function () {
                        me.data.set('proofList[0].bankCard',false)
                    });
                }else {
                    san.nextTick(function () {
                        me.data.set('proofList[0].bankCard',true)
                    });
                }
                break;
            case 4:
                if(this.data.get('proofList[0].mobilePayment') == true){
                    san.nextTick(function () {
                        me.data.set('proofList[0].mobilePayment',false)
                    });
                }else {
                    san.nextTick(function () {
                        me.data.set('proofList[0].mobilePayment',true)
                    });
                }
                break;
            case 5:
                if(this.data.get('proofList[0].otherMaterials') == true){
                    san.nextTick(function () {
                        me.data.set('proofList[0].otherMaterials',false)
                    });
                }else {
                    san.nextTick(function () {
                        me.data.set('proofList[0].otherMaterials',true)
                    });
                }
                break;
        }
    },
    hideLoad: function(){
        this.data.set('showLoading', false);
    },
    revise: function(){
        this.data.set('ifCreate',false);
    },
    messages: {}
});



//////////////////
// WEBPACK FOOTER
// ./src/components/doc-ldbc.js
// module id = 363
// module chunks = 1